import { useContext } from "react";
import { TranslationContext } from "../../contexts/TranslationContext";
import { IUserSearchResult } from "../../services/WebApiClient";
import { DisplayDate } from "../DisplayDate";
import { SortBy } from "../Table/SortBy";
import { IColumn, Table } from "../Table/Table";



export function CustomerSearchTable(props: {
    results: IUserSearchResult[];
    onSelectUser: ((u: IUserSearchResult) => void);
}) {

    const tc = useContext(TranslationContext);

    const columns: IColumn<IUserSearchResult>[] = [
        {
            key: "name",
            content: usr => usr.name,
            header: tc.translator("customer search table col name", "Navn"),
            sort: SortBy.String(usr => usr.name),
        },
        {
            key: "email",
            content: usr => usr.emailAddress,
            header: tc.translator("customer search table col email", "Email"),
            sort: SortBy.String(usr => usr.emailAddress),
        },
        {
            key: "phoneNumber",
            content: usr => usr.phoneNumber,
            header: tc.translator("customer search table col phone", "Telefonnummer"),
            sort: SortBy.String(usr => usr.phoneNumber),
        },
        {
            key: "lastActive",
            content: usr => <DisplayDate date={usr.lastActive} />,
            header: tc.translator("customer search table col lastActive", "Sidst aktiv"),
            sort: SortBy.Date(usr => usr.lastActive),
        },
        {
            key: "numSolutions",
            content: usr => usr.solutions.length + "",
            header: tc.translator("customer search table col numSolutions", "Løsninger"),
            sort: SortBy.Number(usr => usr.solutions.length),
        },
        {
            key: "openUser",
            content: usr => (
                <button className="btn btn-sm btn-outline-primary"
                    onClick={evt => props.onSelectUser(usr)}
                >
                    {tc.translator("customer search table col open btn text", "Vis kunde")}
                </button>
                ),
        }
    ];
    return <Table<IUserSearchResult>
        columns={columns}
        rows={props.results}
        rowKey={usr => usr.userId}
        tableProps={{ className: "table table-striped table-hover customer-search-table" }}
    />
}
